"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_GO_TO_INPUT_WIDTH = void 0;
var DEFAULT_GO_TO_INPUT_WIDTH = '45px';
exports.DEFAULT_GO_TO_INPUT_WIDTH = DEFAULT_GO_TO_INPUT_WIDTH;
//# sourceMappingURL=constants.js.map